import { combineReducers } from 'redux';
import { dmaCodes } from './dmaCode';
export default combineReducers({ dmaCodes });
